import { createContext, useContext } from 'react';

/**
 * Context used to provide the value of `useIsDevUser` app-wide.
 *
 * Meant to only ever be set at `root.tsx` so that it'll be available everywhere
 */
export const IsDevUserContext = createContext(false);

/**
 * Hook to determine whether the current user is a developer and should have
 * access to dev features, such as logs
 */
export function useIsDevUser() {
  return useContext(IsDevUserContext);
}
